import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const SelectWrapper = styled.div`
	font-size: 1rem;
	position: relative;
	border: 1px solid ${colorTheme.allOrders.select.border};
	background-color: ${colorTheme.allOrders.select.background};
	border-radius: 0.75em;
	min-height: 3.12em;
	width: 100%;
	display: grid;
	cursor: pointer;
	user-select: none;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;

	.arrow {
		height: 0.69em;
		width: 1.25em;
		position: absolute;
		top: calc(50% - 0.35em);
		right: 1.38em;
		fill: ${colorTheme.input.select.icon};
	}

	@media screen and (max-width: ${theme.point820}) {
		min-height: 3.93em;
		border-radius: 0.86em;

		.arrow {
			height: 0.78em;
			width: 1.43em;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		min-height: 3.44em;
		border-radius: 0.75em;

		.arrow {
			height: 0.69em;
			width: 1.25em;
		}

`
SelectWrapper.displayName = 'SelectWrapper'

export const OptionsWrap = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	flex-direction: column;
	align-items: flex-start;
	border: 1px solid ${colorTheme.allOrders.select.optionBorderWrap};
	border-radius: .75em;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	background-color: ${colorTheme.allOrders.select.background};
	overflow: hidden;
	z-index: 10;
`
OptionsWrap.displayName = 'OptionsWrap'

export const Option = styled.div`
	color:  ${colorTheme.allOrders.select.text};
	font-size: 1.13em;
	font-style: normal;
	font-weight: 500;
	font-family: ${theme.fontRobotoMedium};
	line-height: normal;
	min-height: 2.5em;
	padding: .55em 1.1em;
	display: flex;
	align-items: center;


	&:not(:last-child){
		border-bottom: 1px solid ${colorTheme.allOrders.select.optionBorder};
	}

	&:hover {
		background-color:${colorTheme.allOrders.select.optionBackgroundHover};
		color: ${colorTheme.allOrders.select.textHover};
	}

	@media screen and (max-width: ${theme.point820}) {
		font-size: 1.29em;
		min-height: 3.5em;
	}

	@media screen and (max-width: ${theme.point720}) {
		font-size: 1.13em;
	}
`
Option.displayName = 'Option'

export const SelectOption = styled.div`
  font-size: 1.13em;
  font-style: normal;
  font-weight: 500;
	font-family: ${theme.fontRobotoMedium};
  line-height: normal;
	max-width: 86%;
  min-height: 2.2em;
  padding: .28em .77em;
	display: flex;
	align-items: center;
	color: ${colorTheme.allOrders.select.text};

	&.active {
		color: ${colorTheme.allOrders.select.textActive};
	}


	@media screen and (max-width: ${theme.point820}) {
		font-size: 1.29em;
	}

	@media screen and (max-width: ${theme.point720}) {
		font-size: 1.13em;
	}
`
